import { axiosGet } from "../../react_axios/Axios"
import { headers, getMemberDashboardCardsUrl, GET_MEMBER_DASHBOARD_CARDS_ACTION_TYPE } from "../../utils/constants"

export const get_memberDashboardCards_action = () => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') != '' && sessionStorage.getItem('UserIDSS') != null ? sessionStorage.getItem('UserIDSS') : null,

        }
        const res = await axiosGet(getMemberDashboardCardsUrl, mapdata, headers);

        dispatch({
            type: GET_MEMBER_DASHBOARD_CARDS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
